import { useEffect, useState } from 'react'

import { fetchAll } from '@/services/deivery-units/fetchAll'

type Filters = {
  codigoAgrupamento?: string
  codigo?: string
}

export const useUnitsListDelivery = (operator: Filters) => {
  const [isLoading, setIsLoading] = useState(false)
  const [tableData, setTableData] = useState<any[]>([])
  const [limit, setLimit] = useState(10)
  const [page, setPage] = useState(1)
  const [search, setSearch] = useState('')
  const [currentFilters, setCurrentFilters] = useState<Filters | undefined>(
    undefined
  )
  const [results, setResults] = useState<number>(0)

  useEffect(() => {
    const defaultFilters: Filters = {
      codigoAgrupamento: operator.codigo
    }

    setCurrentFilters(defaultFilters)
    fetchData(defaultFilters)
  }, [])

  const fetchData = async (filtros: Filters) => {
    setIsLoading(true)

    const payload = {
      codigoAgrupamento: filtros.codigoAgrupamento,
      pagina: page,
      tamanhoDaPagina: limit
    }

    const allData = await fetchAll(payload)
    setTableData(allData.items)
    setResults(allData.total)
    setIsLoading(false)
  }

  const handleFilter = async (filtros: Filters) => {
    setCurrentFilters(filtros)
    await fetchData(filtros)
  }

  const handleLimitChange = (newLimit: number) => {
    setLimit(newLimit)
    setPage(1)
  }

  const refetch = async () => {
    if (currentFilters) {
      await fetchData(currentFilters)
    }
  }

  useEffect(() => {
    if (currentFilters) {
      fetchData(currentFilters)
    }
  }, [page, limit, search])

  return {
    handleFilter,
    handleLimitChange,
    isLoading,
    limit,
    page,
    refetch,
    results,
    search,
    setLimit,
    setPage,
    setSearch,
    tableData
  }
}
